module.exports = __webpack_public_path__ + "static/media/1 24 nøklene.d7cedd9d.mp3";